module.exports = __webpack_public_path__ + "img/services.2739f6e4.png";